<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'orderNo'))"
                       v-model='queryParam.orderNo'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('customer.custName')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.CUSTOMER + 'custName'))"
                       v-model='queryParam.aadhaarName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalStatus')">
              <dict-select
                v-model='queryParam.approvalStatus'
                :dict-code='DICT_CODE.ORDER_STATUS'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <template v-if='toggleSearchStatus'>
            <a-col :md='12' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.APPROVAL + 'TaskSubTime')">
                <a-range-picker
                  v-model='queryParam.createdTime'
                  format='YYYY-MM-DD' />
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='6'>
              <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalTime')">
                <a-range-picker
                  v-model='queryParam.approvalcreatedTime'
                  format='YYYY-MM-DD'
                  style='width: 100%;' />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
        <Dict slot='approvalTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS' :value='text' />
        <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
        <span slot='action' slot-scope='text, record'>
          <!-- slot-scope="text, record" -->
            <a @click='handleDetail(record)'>{{ $t('view') }}</a>
        </span>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.approvalDetail')">
      <div style='padding: 20px;'>
        <approval-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :phoneprops='phoneprops'
          @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getHistoryTask } from '@/webpublicapi/approval'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import ApprovalDetail from './ApprovalDetail'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    ApprovalDetail
  },
  data() {
    return {
      phoneprops:null,
      mobileNo: null,
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'orderNo': '',
        'approvalStatus': '',
        'aadhaarName': '',
        'applyAmtMin': '',
        'applyAmtMax': '',
        'applyDate': undefined
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('order.orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('customer.custName'),
          align: 'left',
          dataIndex: 'aadhaarName'
        },
        {
          title: this.$t('order.applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t('order.applicationDeadline'),
          align: 'left',
          dataIndex: 'duration'
        },
        {
          title: this.$t('approval.TaskSubTime'),
          align: 'left',
          dataIndex: 'shareOrderTime'
        },
        {
          title: this.$t('order.approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t('order.settleStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t('order.approvalTime'),
          align: 'left',
          dataIndex: 'examineTime'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.getDict()
    this.loadData(1)
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getHistoryTask(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    // getQueryParams () {
    //   const { applyDate } = this.queryParam;
    //   const data = {
    //       ...this.queryParam,
    //       applyDateStart: applyDate && this.transformTime(applyDate[0]),
    //       applyDateEnd: applyDate && this.transformTime(applyDate[1]),
    //   }
    //   delete data.applyDate;
    //   var param = Object.assign({}, data)
    //   param.pageNum = this.form.pageNum;
    //   param.pageSize = this.form.pageSize;
    //   return filterObj(param)
    // },
    getQueryParams() {
      console.log('this.queryParam', this.queryParam)
      // console.log('选择了日期吗', this.queryParam.createdTime.length)
      const data = {
        ...this.queryParam
      }
      const searchparam = Object.assign({}, data)
      if (this.queryParam.createdTime) {
        if (this.queryParam.createdTime.length) {
          console.log('选择了日期')
          const starttime = this.queryParam.createdTime[0]._d
          const endtime = this.queryParam.createdTime[1]._d
          const startDate1 = new Date(starttime).toISOString().split('T')[0]
          const endtime2 = new Date(endtime).toISOString().split('T')[0]
          searchparam.applyDateStart = startDate1
          searchparam.applyDateEnd = endtime2
        }

      }
      if (this.queryParam.approvalcreatedTime) {
        if (this.queryParam.approvalcreatedTime.length) {
          console.log('选择了审批日期')
          const starttime = this.queryParam.approvalcreatedTime[0]._d
          const endtime = this.queryParam.approvalcreatedTime[1]._d
          const startDate1 = new Date(starttime).toISOString().split('T')[0]
          const endtime2 = new Date(endtime).toISOString().split('T')[0]
          searchparam.approvalDateStart = startDate1
          searchparam.approvalDateEnd = endtime2
        }
      }
      searchparam.pageNum = this.form.pageNum
      searchparam.pageSize = this.form.pageSize
      console.log('searchparam', searchparam)
      return searchparam
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.aadhaarName = ''
      that.queryParam.applyDate = undefined
      that.queryParam.createdTime = ''
      that.queryParam.approvalcreatedTime = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.orderId
      this.custInfoId = row.custInfoId
      this.taskId = row.taskId
      this.phoneprops = row.mobileNo
      this.changeModal(true)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
